import {
  FilterPanel,
  StorageKeys,
  TextInput,
} from "@validereinc/common-components";
import React from "react";

export const WorkflowsCategoriesFilterPanel = ({
  filterConfigStorageKey,
}: Pick<StorageKeys, "filterConfigStorageKey">) => {
  return (
    <FilterPanel
      storageKey={filterConfigStorageKey}
      defaultActiveKeys={["Filters"]}
      filters={[
        {
          component: (
            <TextInput
              key="workflows-categories-name-filter"
              name="name"
              placeholder="Search Categories..."
              type="search"
              autoComplete="on"
              isInline
            />
          ),
        },
      ]}
    />
  );
};
